import { create } from 'zustand';

const DEFAULT_POSITION = {
  bottom: 16,
  right: 16,
};

const INIT_STATE = {
  visible: true,
  position: DEFAULT_POSITION,
  variant: 'primary' as const,
};

const useIssueReportStore = create<{
  visible: boolean;
  position: {
    bottom: number;
    right: number;
  };
  variant: 'primary' | 'secondary';

  setVisible: (visible: boolean) => void;
  setPosition: (position: { bottom: number; right: number }) => void;
  setVariant: (variant: 'primary' | 'secondary') => void;
  clear: () => void;
}>(set => ({
  ...INIT_STATE,

  setVisible(visible) {
    set({ visible });
  },
  setPosition(position) {
    set({ position });
  },
  setVariant(variant) {
    set({ variant });
  },
  clear() {
    set(INIT_STATE);
  },
}));

export default useIssueReportStore;
